<template>
  <Layout>
    <template #header>
      <div class="row">
        制动力分配功能
        <!-- <span>降级模式：</span>
        <span class="q-mr-md">三轮制动</span> <span>两轮制动 </span> -->
      </div>
    </template>
    <div class="row q-col-gutter-x-md full-height">
      <div class="col-5 column justify-around">
        <q-card flat bordered class="full-height column">
          <q-card-section
            class="row q-pb-none text-center"
            style="font-size: 22px"
          >
            请选择想要失效的轮，体验不同轮制动的功能表现，体验过程中请将车辆刹停
          </q-card-section>
          <q-card-section class="row q-pb-none" style="flex: 1">
            <!-- car   -->
            <div
              class="row justify-around items-center car-img"
              style="flex: 1"
            >
              <!-- car -->
              <q-img
                :src="'/底盘透明_纵向_不带轮胎.png'"
                :style="{
                  height: IMG_HEIGHT + 'px',
                  width: IMG_WIDTH + 'px',
                }"
                spinner-color="white"
                fit="contain"
              >
                <!-- 轮胎 -->
                <q-img
                  v-for="(tire, index) in tires"
                  :key="tire.name"
                  :style="{
                    position: 'absolute',
                    left: tire.position.left + 'px',
                    top: tire.position.top + 'px',
                    right: tire.position.right + 'px',
                    bottom: tire.position.bottom + 'px',
                    width: TIRES_WIDTH + 'px',
                    height: TIRES_HEIGHT + 'px',
                  }"
                  :src="tire.src"
                  alt="tire"
                >
                  <div
                    class="absolute-full"
                    :style="`  background-color:${
                      tire.status === 'disable'
                        ? 'rgba(255, 0, 0, 0.5)'
                        : 'rgba(0, 255, 0, 0.5)'
                    }  ;
                        border-radius: 8px;`"
                  ></div>
                  <div
                    :style="{
                      position: 'absolute',
                      left: tire.gaugePosition.left + 'px',
                      top: tire.gaugePosition.top + 'px',
                      right: tire.gaugePosition.right + 'px',
                      bottom: tire.gaugePosition.bottom + 'px',
                      zIndex: 9,
                      transform: `rotate(180deg)`,
                    }"
                    class="absolute"
                  >
                    <ArrowGauge
                      :value="tire.value"
                      :max="3000"
                      :color="'#ffeb3b'"
                    />
                  </div>
                  <div
                    :style="{
                      position: 'absolute',
                      left: tire.radioPosition.left + 'px',
                      top: tire.radioPosition.top + 'px',
                      right: tire.radioPosition.right + 'px',
                      bottom: tire.radioPosition.bottom + 'px',
                      zIndex: 9,
                    }"
                    class="absolute"
                  >
                    <q-option-group
                      :model-value="tire.status"
                      @update:model-value="
                        (value) => handleTireStatusChange(index, value)
                      "
                      :options="radioOptions"
                      :disable="tire.disable"
                      size="lg"
                      color="red"
                      :left-label="tire.name.includes('左') ? true : false"
                    />
                  </div>
                </q-img>
              </q-img>
            </div>
          </q-card-section>
        </q-card>
      </div>
      <div class="col-7 column q-col-gutter-y-md overflow-hidden">
        <div style="flex: 1">
          <q-card flat bordered class="column full-height">
            <q-card-section class="q-pb-none">
              <div class="text-h6"></div>
            </q-card-section>

            <q-card-section class="overflow-hidden q-pa-none" style="flex: 1">
              <div class="full-height column overflow-hidden">
                <!-- <div class="overflow-hidden" style="flex: 1"></div> -->
                <div class="overflow-hidden relative-position" style="flex: 1">
                  <q-btn
                    class="absolute"
                    style="z-index: 2; left: 50px; top: 30px"
                    color="secondary"
                    glossy
                    :icon="'swap_horiz'"
                    @click="slide = slide === 1 ? 2 : 1"
                  />
                  <DomainControlCharts
                    class="absolute"
                    :style="{
                      top: '0px',
                      transform:
                        slide === 1 ? 'translateX(0px)' : 'translateX(5000px)',
                    }"
                    :max="180"
                    :min="-180"
                    :x-axis-length="LENGTH"
                    :series="optionsSBW"
                  />
                  <DomainControlCharts
                    class="absolute"
                    :style="{
                      top: '0px',
                      transform:
                        slide === 2 ? 'translateX(0px)' : 'translateX(5000px)',
                    }"
                    :max="5"
                    :min="-5"
                    :x-axis-length="LENGTH"
                    :series="optionsLongdAxleStAng"
                  />
                </div>
                <div class="overflow-hidden relative-position" style="flex: 1">
                  <!-- <q-btn
                    class="absolute"
                    style="z-index: 2; left: 50px; top: 0px"
                    color="secondary"
                    glossy
                    :icon="'swap_horiz'"
                    @click="slide2 = slide2 === 1 ? 2 : 1"
                  /> -->
                  <DomainControlCharts
                    class="absolute"
                    :style="{
                      top: '0px',
                      transform:
                        slide === 1 ? 'translateX(0px)' : 'translateX(5000px)',
                    }"
                    :max="10"
                    :min="-10"
                    :x-axis-length="LENGTH"
                    :series="optionsYawRate"
                  />
                  <DomainControlCharts
                    class="absolute"
                    :style="{
                      top: '0px',
                      transform:
                        slide === 2 ? 'translateX(0px)' : 'translateX(5000px)',
                    }"
                    :max="1.2"
                    :min="-1.2"
                    :x-axis-length="LENGTH"
                    :series="optionsLongdAcc"
                  />
                  <!-- <Charts :options="optionsYawRate" />
                  <Charts :options="optionsLongdAcc" /> -->
                </div>
              </div>
            </q-card-section>
          </q-card>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script setup lang="ts">
import { reactive, ref, watch } from "vue";
import {
  buildStatus,
  FunctionStatus,
  getDefaultSeriesData,
  optionseries1,
  optionseries2,
  optionseries3,
  optionseries4,
  parseStatus,
  PlayStatus,
  radioOptions,
} from "./helper/bfd";
import Layout from "./components/Layout.vue";
import useInitialize from "@/composables/domainControl/useInitialize";
import { SERVICE } from "@/services/domainControl/define";
import { NOTIFY } from "@/services/domainControl/bfd";
import { useQuasar } from "quasar";
import { useDomainControlStore } from "@/stores/domainControl";
import ArrowGauge from "@/components/ArrowGauge.vue";
import { onBeforeRouteLeave } from "vue-router";
import DomainControlCharts from "@/components/DomainControlCharts";
import { generateNumbers } from "@/utils/math";
const LENGTH = 5;
const decreasingSequence = generateNumbers(LENGTH, 0);

const $q = useQuasar();
const domainControlStore = useDomainControlStore();

const IMG_HEIGHT = 550;
const CAR_HEIGHT = 1810;
const IMG_RATE = IMG_HEIGHT / CAR_HEIGHT;
const IMG_WIDTH = 813 * IMG_RATE;
const TIRES_TOP = 245 * IMG_RATE;
const TIRES_BOTTOM = 367 * IMG_RATE;
const TIRES_HEIGHT = 250* IMG_RATE;
const TIRES_WIDTH = 96 * IMG_RATE;
const TIRES_RIGHT = 76 * IMG_RATE;
const TIRES_LEFT = 90 * IMG_RATE;

const seriesData = ref(getDefaultSeriesData());
const optionsSBW = ref(optionseries1());
const optionsLongdAxleStAng = ref(optionseries2());
const optionsYawRate = ref(optionseries3());
const optionsLongdAcc = ref(optionseries4());
const playStatus = ref<PlayStatus>("pause");
const notifyData = reactive({} as Partial<DomianControl.DMCNotifyData>);
const slide = ref(1);
const slide2 = ref(1);

const tires = ref([
  {
    name: "左前",
    value: 0,
    status: "enable",
    disable: false,
    src: "/轮胎左.png", // 轮胎图片路径
    position: { left: TIRES_LEFT, top: TIRES_TOP }, // 轮胎在车图片中的位置
    gaugePosition: { left: -50, top: 20 },
    radioPosition: { left: -130, top: 0 },
  },
  {
    name: "右前",
    value: 0,
    status: "enable",
    disable: false,
    src: "/轮胎左.png",
    position: { right: TIRES_RIGHT, top: TIRES_TOP },
    gaugePosition: { right: -50, top: 20 },
    radioPosition: { right: -130, top: 0 },
  },
  {
    name: "右后",
    value: 0,
    status: "enable",
    disable: false,
    src: "/轮胎左.png",
    position: { right: TIRES_LEFT, bottom: TIRES_BOTTOM },
    gaugePosition: { right: -50, bottom: -20 },
    radioPosition: { right: -130, bottom: 0 },
  },
  {
    name: "左后",
    value: 0,
    status: "enable",
    disable: false,
    src: "/轮胎左.png",
    position: { left: TIRES_RIGHT, bottom: TIRES_BOTTOM },
    gaugePosition: { left: -50, bottom: -20 },
    radioPosition: { left: -130, bottom: 0 },
  },
]);

watch(
  () => seriesData.value,
  (newValue) => {
    const {
      UIRx_SBW_HWAAng,
      UIRx_AxleStAng_FA,
      UIRx_AxleStAng_RA,
      UIRx_ACUYawRate,
      UIRx_ACULongdAcc,
    } = newValue;

    (optionsSBW.value as any)[0].data = UIRx_SBW_HWAAng;
    (optionsLongdAxleStAng.value as any)[0].data = UIRx_AxleStAng_FA;
    (optionsLongdAxleStAng.value as any)[1].data = UIRx_AxleStAng_RA;

    (optionsYawRate.value as any)[0].data = UIRx_ACUYawRate;
    (optionsLongdAcc.value as any)[0].data = UIRx_ACULongdAcc;
  }
);

const parseData = async (value: DomianControl.BFDNotifyData) => {
  // 开始：驾驶员目标制动力（UIRx_DrvrReqTrgtFxBrk_Bch1）从0到！=0开始绘制
  if (notifyData.UIRx_DrvrReqTrgtFxBrk_Bch1 === 0) {
    if (value.UIRx_DrvrReqTrgtFxBrk_Bch1 !== 0) {
      await handlePlayStatusChange("play");
    }
  }
  // 停止：UIRx_VehSdsl=1（车辆Standstill）
  if (value.UIRx_VehSdsl === 1) {
    await handlePlayStatusChange("pause");
  }

  Object.keys(value).forEach((key) => {
    notifyData[key] = value[key];
  });
  // update 制动力
  tires.value.map((tire) => {
    if (tire.name === "左前") {
      tire.value = notifyData.UIRx_WhlBrkTqAct_FL_BCh1 || 0
    } else if (tire.name === "右前") {
      tire.value = notifyData.UIRx_WhlBrkTqAct_FR_BCh1 || 0
    } else if (tire.name === "左后") {
      tire.value = notifyData.UIRx_WhlBrkTqAct_RL_BCh1 || 0
    } else if (tire.name === "右后") {
      tire.value = notifyData.UIRx_WhlBrkTqAct_RR_BCh1 || 0
    }
  });
};

const handleNotify = async (data: DomianControl.BFDNotifyData) => {
  await parseData(data);
  if (playStatus.value === "play") parseSeriesData(data);
};

const parseSeriesData = (data: DomianControl.BFDNotifyData) => {
  const res = [
    "UIRx_SBW_HWAAng",
    "UIRx_AxleStAng_FA",
    "UIRx_AxleStAng_RA",
    "UIRx_ACUYawRate",
    "UIRx_ACULongdAcc",
  ].reduce((per, key) => {
    let value = data[key];
    // if (key.includes("RRWhlSpd")) value = rpmToKph(value);
    const curList = seriesData.value[key] || [];
    if (curList.length >= decreasingSequence.length) curList.shift();
    curList.push(value);
    per[key] = curList;
    return per;
  }, {} as DomianControl.BFDSeriesData);
  seriesData.value = res;
};

const handlePlayStatusChange = async (value: PlayStatus) => {
  if (value === "play") {
    seriesData.value = getDefaultSeriesData();
    if (!isNotifyed.value) {
      $q.loading.show();
      await startNotifications().finally(() => $q.loading.hide());
    }
  }
  playStatus.value = value;
};
const parseOutputValue = (value: DomianControl.OutputValue) => {
  const {
    UITx_DisableBrk_FL,
    UITx_DisableBrk_FR,
    UITx_DisableBrk_RL,
    UITx_DisableBrk_RR,
  } = value;

  tires.value.map((tire) => {
    if (tire.name === "左前") {
      tire.status = parseStatus(UITx_DisableBrk_FL);
    } else if (tire.name === "右前") {
      tire.status = parseStatus(UITx_DisableBrk_FR);
    } else if (tire.name === "左后") {
      tire.status = parseStatus(UITx_DisableBrk_RL);
    } else if (tire.name === "右后") {
      tire.status = parseStatus(UITx_DisableBrk_RR);
    }
  });
};

const handleTireStatusChange = (index: number, value: FunctionStatus) => {
  const tire = tires.value[index || 0];
  tire.status = value;

  const data = {} as any;
  const signalValue = buildStatus(value);
  // 左前轮制动力失效开关:UITx_DisableBrk_FL
  // 右前轮制动力失效开关:UITx_DisableBrk_FR
  // 左后轮制动力失效开关:UITx_DisableBrk_RL
  // 右后轮制动力失效开关:UITx_DisableBrk_RR
  if (tire.name === "左前") {
    data.UITx_DisableBrk_FL = signalValue;
  } else if (tire.name === "右前") {
    data.UITx_DisableBrk_FR = signalValue;
  } else if (tire.name === "左后") {
    data.UITx_DisableBrk_RL = signalValue;
  } else if (tire.name === "右后") {
    data.UITx_DisableBrk_RR = signalValue;
  }
  domainControlStore.writeOutputValue(data);
  updateTiresStatus();
};

const updateTiresStatus = () => {
  const disableCount = tires.value.filter(
    (tire) => tire.status === "disable"
  ).length;

  if (disableCount === 2) {
    tires.value.forEach((tire) => {
      if (tire.status !== "disable") {
        tire.disable = true;
      }
    });
  }

  if (disableCount < 2) {
    tires.value.forEach((tire) => {
      tire.disable = false;
    });
  }
};

const { startNotifications, stopNotifications, isNotifyed } = useInitialize({
  handleNotify,
  SERVICE_UUID: SERVICE.uuid,
  NOTIFY_UUID: NOTIFY.uuid,
  parseOutputValue: parseOutputValue,
});

onBeforeRouteLeave((to, from) => {
  const validata = tires.value.every((item) => item.status === "enable");
  console.log("[BOWEN_LOG] 🚀 ~~ onBeforeRouteLeave ~~ validata:", validata);
  if (!validata) {
    $q.notify({
      type: "warning",
      message: `请将所有调为正常后再切换其他功能`,
      timeout: 1000,
    });
    return false;
  }

  // const answer = window.confirm(
  //   'Do you really want to leave? you have unsaved changes!'
  // )
  // // 取消导航并停留在同一页面上
  // if (!answer) return false
});

// onMounted(() => {
//   setInterval(() => {
//     handleNotify(generateMockDURNofifyData() as any);
//   }, 50);
// });
</script>

<style scoped lang="scss">
.car-img {
  :deep(.q-img__content) > div {
    background-color: transparent;
    padding: 0;
  }
}

.q-img {
  overflow: unset;
}

:deep(.q-toggle__inner--falsy) {
  .q-toggle__track {
    background: #4caf50;
  }
}

:deep(.q-radio__label) {
  font-size: 18px;
}

:deep(.q-radio.disabled) {
  opacity: 0.3 !important;
}
</style>
